import { ContainerModule } from 'inversify'
import TYPES from 'config/inversify.types'
import { CloudIntegrationStore } from 'store/cloud-integration'
import { CloudIntegrationServiceImpl } from './cloud-integration.service.impl'

export const CloudIntegrationModule = new ContainerModule((bind) => {
    bind(TYPES.CloudIntegrationService).to(CloudIntegrationServiceImpl).inSingletonScope()
    bind(TYPES.CloudIntegrationStore).to(CloudIntegrationStore).inSingletonScope()
})
